import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import JobRow from 'components/modules/shipments/tracking/DriverJobRow';
import { JOB_CANCELED, JOB_CLOSED } from 'constants/JobStatus';
import Spinner from '../../../ui/Spinner';
class DriverJobsPopover extends Component {
    constructor() {
        super(...arguments);
        this.renderHeader = () => {
            const { t } = this.props;
            if (!this.props.hasActiveJobs && !this.props.jobs.length) {
                return (React.createElement("tr", { style: { textAlign: 'center', paddingTop: '4px' } },
                    React.createElement("td", null,
                        React.createElement("p", { className: "pt-2" }, t('NO_ACTIVE_JOBS')))));
            }
            if (this.props.jobs &&
                this.props.jobs.length &&
                _.isObject(this.props.jobs[0])) {
                return (React.createElement("tr", null,
                    React.createElement("th", null, titleize(t('SHIPMENT'))),
                    React.createElement("th", null, titleize(t('ORIGIN'))),
                    React.createElement("th", null, titleize(t('DESTINATION'))),
                    React.createElement("th", null, t('STATUS'))));
            }
            return (React.createElement("tr", { style: { display: 'flex', flexWrap: 'wrap', justifyContent: 'center' } },
                React.createElement("td", null,
                    React.createElement("div", { className: "flex mx-auto pt-2" },
                        React.createElement(Spinner, { showMessage: true, message: t('LOADING_JOBS'), style: { color: '#21b88e' } })))));
        };
    }
    render() {
        const { driver: { fullName, phone }, t, } = this.props;
        const viewableJobs = this.props.jobs.filter((job) => {
            if (job.current_status === JOB_CANCELED ||
                job.current_status === JOB_CLOSED) {
                return false;
            }
            return true;
        });
        const phoneLink = `tel: ${phone}`;
        return (React.createElement("div", { className: "driver-jobs-popover" },
            React.createElement("h5", { className: "title" }, t('JOBS_FOR_NAME', { name: fullName })),
            phone && (React.createElement("span", { className: "phone" },
                React.createElement("i", { className: "fa fa-phone" }),
                React.createElement("a", { href: phoneLink }, phone))),
            React.createElement("div", { className: "content" },
                React.createElement(Table, { striped: true, condensed: true },
                    React.createElement("thead", null, this.renderHeader()),
                    React.createElement("tbody", null, viewableJobs.map((job, index) => (React.createElement(JobRow, { job: job, key: index, onOpenShipment: this.props.onOpenShipment }))))))));
    }
}
DriverJobsPopover.propTypes = {
    driver: PropTypes.shape({
        fullName: PropTypes.string,
        phone: PropTypes.string,
    }).isRequired,
    jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
    onOpenShipment: PropTypes.func.isRequired,
    hasActiveJobs: PropTypes.bool,
};
export default withTranslation()(DriverJobsPopover);
